import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import PlaceHolder from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/placeholder';
import CountryCodeSelector from './countryCode';
import {
  InputWrapper,
  Children,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/input';
import { FormatTypes } from '../../../../../../../../../constants/templateDictionaries';
// import { DownArrow } from '../../../../../../editJournal/toolset/assets/icons';

class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.inputWrapperRef = React.createRef();
  }

  componentDidMount = () => {
    const { nodeProps } = this.props;
    const { node } = nodeProps;

    if (node.type === 'phone_number' || node.type === 'sender_phone_number') {
      this.updateInputWrapperWidth();
      window.addEventListener('resize', this.updateInputWrapperWidth);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateInputWrapperWidth);
  };

  componentDidUpdate = (_, prevState) => {
    const { nodeProps } = this.props;
    const { node } = nodeProps;
    if (node.type === 'phone_number' || node.type === 'sender_phone_number') {
      if (this.inputWrapperRef && this.inputWrapperRef.current) {
        const { inputWrapperWidth } = prevState;
        const element = this.inputWrapperRef.current;
        const bounds = element.getBoundingClientRect();
        const { width } = bounds;
        if (inputWrapperWidth !== width) {
          this.setState({ inputWrapperWidth: width });
        }
      }
    }
  };

  updateInputWrapperWidth = () => {
    if (this.inputWrapperRef && this.inputWrapperRef.current) {
      const element = this.inputWrapperRef.current;
      const bounds = element.getBoundingClientRect();
      const { width } = bounds;
      this.setState({ inputWrapperWidth: width });
    }
  };

  setCountryCode = (_, countryData) => {
    const {
      nodeProps: { node, editor },
    } = this.props;

    editor
      .setNodeByKey(node.key, {
        data: {
          dialCode: countryData.dialCode,
          countryCode: countryData.countryCode,
          name: countryData.name,
        },
      })
      .focus();
  };

  render() {
    const { nodeProps, placeHolder } = this.props;
    const { node, attributes, children, isFocused } = nodeProps;

    const { data, type } = node;

    const { inputWrapperWidth } = this.state;

    let countryCode;
    if (type === 'phone_number' || type === 'sender_phone_number') {
      const countryData = data.toJSON();
      ({ countryCode } = countryData);
    }

    return (
      <InputWrapper
        {...attributes}
        ref={this.inputWrapperRef}
        nodeType={node.type}
        isFocused={isFocused}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        inputWrapperWidth={inputWrapperWidth}
      >
        {(node.type === 'phone_number' ||
          node.type === 'sender_phone_number') && (
          <CountryCodeSelector
            countryCode={countryCode}
            setCountryCode={this.setCountryCode}
          />
        )}

        <Children nodeType={node.type}>{children}</Children>
        <PlaceHolder
          contentEditable={false}
          nodeType={node.type}
          isFocused={isFocused}
          nodeText={node.text}
        >
          {placeHolder}
        </PlaceHolder>
      </InputWrapper>
    );
  }
}

Input.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  placeHolder: propTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;

  if (formatType === FormatTypes.RESUME) {
    return {
      userPreferences: state.editResumeFormReducer.userPreferences,
    };
  }

  if (formatType === FormatTypes.COVER_LETTER) {
    return {
      userPreferences: state.editCoverLetterFormReducer.userPreferences,
    };
  }

  return null;
};

export default connect(mapStateToProps)(Input);
